<div class="immo-job-container mt-3 ml-auto mr-auto">
  <div class="filters-container">
    <mat-form-field class="select-field mr-3" appearance="outline">
      <mat-select matInput placeholder="Jaar" [(ngModel)]="selectedYear">
        <mat-option *ngFor="let option of yearOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field mr-3" appearance="outline">
      <mat-select matInput placeholder="Job type" [(ngModel)]="selectedJobType">
        <mat-option
          *ngFor="let option of jobTypeOptions"
          [value]="option.value"
        >
          {{ option.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="!loadingPlacers" class="mr-3" appearance="outline">
      <mat-select
        matInput
        placeholder="Installateur"
        [(ngModel)]="selectedPlacer"
        [compareWith]="compareEntities"
      >
        <mat-option [value]="allPlacerOption">Alle installateurs</mat-option>
        <mat-option
          *ngFor="let option of placerOptions; trackBy: trackById"
          [value]="option"
        >
          {{ option.user?.firstName | personName: option.user?.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field mr-3" appearance="outline">
      <mat-select
        matInput
        placeholder="Plaatsings type"
        [(ngModel)]="selectedPlacementType"
        [compareWith]="compareOrdinalEnum"
      >
        <mat-option [value]="allPlacementOption"
          >Alle plaatsings types</mat-option
        >
        <mat-option
          *ngFor="let option of placementTypeOptions"
          [value]="option"
        >
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button class="btn btn-accent" (click)="getOverview()" mat-flat-button>
      Toon
    </button>
  </div>
  <div *ngIf="data != null" class="calendar-container ml-auto mr-auto">
    <table id="immo-job-table">
      <thead>
        <tr>
          <th class="transparent"></th>
          <th *ngFor="let num of daysNum" class="dark">
            {{ num }}
          </th>
          <th>Totaal</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let month of data.months">
          <tr>
            <td class="dark">{{ month.display }}</td>
            <ng-container *ngFor="let num of daysNum">
              <ng-container
                *ngIf="
                  month.days?.length > 0 && (month?.days)[num - 1]?.total > 0;
                  else empty
                "
              >
                <td
                  [class.orange]="
                    month.days[num - 1].total >= 60 &&
                    month.days[num - 1].total < 80
                  "
                  [class.yellow]="
                    month.days[num - 1].total >= 80 &&
                    month.days[num - 1].total < 90
                  "
                  [class.green]="month.days[num - 1].total >= 100"
                >
                  {{ month.days[num - 1].total }}
                </td>
              </ng-container>
              <ng-template #empty>
                <td></td>
              </ng-template>
            </ng-container>
            <td>
              <b *ngIf="month.days?.length > 0 && month.total > 0">
                {{ month.total }}
              </b>
            </td>
          </tr>
        </ng-container>
        <tr>
          <td class="transparent"></td>
          <ng-container *ngFor="let num of daysNum">
            <td class="transparent"></td>
          </ng-container>
          <td>{{ data.total }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
